import { render, staticRenderFns } from "./Room.vue?vue&type=template&id=253d274d&"
import script from "./Room.vue?vue&type=script&lang=ts&"
export * from "./Room.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports